module.exports = __webpack_public_path__ + "img/launchpad-rocket-bsc.ff412e82.svg";